import {Box, Chip, TextField} from "@mui/material";
import {Autocomplete} from "@mui/lab";

const CompanyCreateInfoPage = ({company, setField}) => {

  return (<>
    <Box sx={{display: "flex",
      flexDirection: "column",
      alignItems: "left",
      justifyContent: "center"}}>
      <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <TextField
            required
            sx={{width: "48%"}}
            margin="dense"
            id="name"
            name="name"
            label="Company Name"
            type="text"
            onChange={(e) => setField("name", e.target.value)}
            value={company.name}
        />
        <TextField
            sx={{width: "48%"}}
            margin="dense"
            id="industry"
            name="industry"
            label="Company Industry"
            type="text"
            onChange={(e) => setField("industry", e.target.value)}
            value={company.industry}
        />
      </Box>

      <TextField
          required
          multiline
          fullWidth
          minRows={3}
          sx={{width: "100%"}}
          margin="dense"
          id="info"
          name="info"
          label="Company Information"
          type="text"
          onChange={(e) => setField("info", e.target.value)}
          value={company.info}
      />
      <TextField
          multiline
          fullWidth
          minRows={3}
          sx={{width: "100%"}}
          margin="dense"
          id="company Solution"
          name="Company Solution"
          label="Company Solution"
          type="text"
          onChange={(e) => setField("companySolution", e.target.value)}
          value={company.companySolution}
      />
      <TextField
          margin="dense"
          fullWidth
          id="companyVertical"
          name="Company Vertical"
          label="Company Vertical"
          type="text"
          onChange={(e) => setField("companyCategory", e.target.value)}
          value={company.companyCategory}
      />

      <TextField
          margin="dense"
          fullWidth
          id="CompanyValueProposition"
          name="Company Value Proposition"
          label="Company Value Proposition"
          type="text"
          onChange={(e) => setField("valueProposition", e.target.value)}
          value={company.valueProposition}
      />

      {/* New ICP Field */}
      <TextField
          multiline
          fullWidth
          minRows={2}
          maxRows={4}
          sx={{width: "100%"}}
          margin="dense"
          id="icp"
          name="icp"
          label="ICP (Ideal Customer Profile)"
          type="text"
          placeholder="Describe your ideal customer profile"
          onChange={(e) => setField("icp", e.target.value)}
          value={company.icp || ''}
      />

      <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "start"}}>
        <Autocomplete
            multiple
            id="tags-filled"
            sx={{mt: "8px", width: "22%", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
            options={[].map((option) => option.title)}
            freeSolo
            value={company.personasProduct}
            onChange={(event, newValue) => {
              setField("personasProduct", newValue)
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip sx={{ height: 'auto','& .MuiChip-label': {
                        display: 'block',
                        whiteSpace: 'normal',
                      },
                    }} aria-multiline variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Persona Users"
                />
            )}
        />
        <Autocomplete
            multiple
            sx={{mt: "8px", width: "22%", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
            id="tags-filled"
            options={[].map((option) => option.title)}
            freeSolo
            value={company.personasSeller}
            onChange={(event, newValue) => {
              setField("personasSeller", newValue)
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip sx={{ height: 'auto','& .MuiChip-label': {
                        display: 'block',
                        whiteSpace: 'normal',
                      },
                    }} aria-multiline variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Persona Buyer"
                />
            )}
        />
        <Autocomplete
            multiple
            id="tags-filled"
            sx={{mt: "8px", width: "22%", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
            options={[].map((option) => option.title)}
            freeSolo
            value={company.companyDifferentiators}
            onChange={(event, newValue) => {
              setField("companyDifferentiators", newValue)
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip sx={{ height: 'auto','& .MuiChip-label': {
                        display: 'block',
                        whiteSpace: 'normal',
                      },
                    }} variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Company Differentiators"
                />
            )}
        />
        <Autocomplete
            multiple
            id="tags-filled"
            sx={{mt: "8px", width: "22%", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
            options={[].map((option) => option.title)}
            freeSolo
            value={company.companyStandards}
            onChange={(event, newValue) => {
              setField("companyStandards", newValue)
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip sx={{ height: 'auto','& .MuiChip-label': {
                        display: 'block',
                        whiteSpace: 'normal',
                      },
                    }} variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Customer Standards"
                />
            )}
        />
      </Box>

      {/* New Profile Fields Section */}
      <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "start", mt: 2}}>
        {/* Languages */}
        <Autocomplete
            multiple
            id="languages-autocomplete"
            sx={{mt: "8px", width: "30%", "& .MuiAutocomplete-inputRoot" : {minHeight: "80px"}}}
            options={[].map((option) => option.title)}
            freeSolo
            value={company.languages || []}
            onChange={(event, newValue) => {
              setField("languages", newValue);
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Languages"
                />
            )}
        />

        {/* Company Type */}
        <Autocomplete
            multiple
            id="company-type-autocomplete"
            sx={{mt: "8px", width: "30%", "& .MuiAutocomplete-inputRoot" : {minHeight: "80px"}}}
            options={[].map((option) => option.title)}
            freeSolo
            value={company.companyType || []}
            onChange={(event, newValue) => {
              setField("companyType", newValue);
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Company Type"
                />
            )}
        />

        {/* Target Countries */}
        <Autocomplete
            multiple
            id="target-countries-autocomplete"
            sx={{mt: "8px", width: "30%", "& .MuiAutocomplete-inputRoot" : {minHeight: "80px"}}}
            options={[].map((option) => option.title)}
            freeSolo
            value={company.targetCountries || []}
            onChange={(event, newValue) => {
              setField("targetCountries", newValue);
            }}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip variant="filled" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    fullWidth
                    {...params}
                    label="Target Countries"
                />
            )}
        />
      </Box>
    </Box>
  </>);
}
export default CompanyCreateInfoPage;
